import type { ShowroomCanvas, ShowroomEventsPayloadMap } from '../webGlApp.types';

export function sendEvent<K extends keyof ShowroomEventsPayloadMap, V extends ShowroomEventsPayloadMap[K]>(
  canvas: ShowroomCanvas,
  eventName: K,
  detail: V
) {
  canvas.dispatchEvent(new CustomEvent(eventName, { detail }));
}
